import { render, staticRenderFns } from "./HomeBrandsAvailable.vue?vue&type=template&id=021e1e3e&scoped=true&"
var script = {}
import style0 from "./HomeBrandsAvailable.vue?vue&type=style&index=0&id=021e1e3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021e1e3e",
  null
  
)

export default component.exports